'use strict';
var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input) {
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.setAttribute('for', input.id);
    label.textContent = input.name;
    input.parentElement.appendChild(label);
    input.setAttribute('placeholder', input.name.charAt(0).toUpperCase() + input.name.slice(1));
});

//# sourceMappingURL=js_task_fix_form_DOM.204ea18a.js.map
